module.exports = __webpack_public_path__ + "img/img-sd.67c48d96.png";